class MvSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.dots = [];
    this.currentIndex = 0;
    this.timer = null;
    this.isHovering = false;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.mv-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.mv-slider__dot'));

    if (this.slides.length === 0) return;

    this.autoplayEnabled = this.dataset.autoplay === 'true';
    const speedSec = parseInt(this.dataset.speed, 10);
    this.intervalMs = (Number.isFinite(speedSec) ? speedSec : 5) * 1000;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    if (this.slides.length > 1) {
      this.addEventListener('mouseenter', () => {
        this.isHovering = true;
        this.stopAutoplay();
      });
      this.addEventListener('mouseleave', () => {
        this.isHovering = false;
        this.startAutoplay();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else if (!this.isHovering) {
          this.startAutoplay();
        }
      });

      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index) {
    if (index === this.currentIndex || index < 0 || index >= this.slides.length) return;

    const prev = this.slides[this.currentIndex];
    const next = this.slides[index];

    prev.classList.remove('is-active');
    prev.setAttribute('aria-hidden', 'true');

    next.classList.add('is-active');
    next.removeAttribute('aria-hidden');

    if (this.dots.length) {
      this.dots[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');
      this.dots[index]?.classList.add('is-active');
      this.dots[index]?.setAttribute('aria-selected', 'true');
    }

    this.currentIndex = index;
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.slides.length <= 1) return;
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.nextSlide(), this.intervalMs);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (!this.autoplayEnabled || this.isHovering) return;
    this.startAutoplay();
  }
}

if (!customElements.get('mv-slider')) {
  customElements.define('mv-slider', MvSlider);
}
